import S from 's-js';
import { IAjax } from 'lib/Ajax';
import { CachedModelLoader } from 'lib/CachedModelLoader';

import { PCCache } from 'data/PCCache';

import { BerthCapability, BerthCapabilityOptions } from 'data/models/BerthCapability';
import { Domain, DomainOptions } from 'data/models/Domain';

import { OrderableLookups, OrderableLookupsParams } from 'portcall/orderablelookups/model';

export function BerthLookups(
    loader : CachedModelLoader<Domain, DomainOptions>,
    domain : Domain,
    ajax : IAjax,
    data : PCCache,
    orderableLookupsModel : <TItem extends { Url : () => string | null }, TData>(params : OrderableLookupsParams<TItem, TData>) => OrderableLookups<TItem>
) {
    const portLookups = orderableLookupsModel({
            supportsAdd: false,
            items: domain.Ports,
            orderProp: p => p.Order,
            itemKey: p => p.Id()
        }),
        capabilityLookups = orderableLookupsModel({
            supportsAdd: true,
            addClient: ajax.Url<BerthCapability, BerthCapabilityOptions>(() => domain.BerthCapabilitiesUrl() || ''),
            items: domain.BerthCapabilities.filter(c => c.Active()),
            cacheCollection: data.BerthCapabilities,
            orderProp: c => c.Order,
            itemFactory: order => new BerthCapability({
                Id: 0,
                Active: true,
                Name: '--',
                Order: order
            }),
            itemKey: c => c.Id(),
            deleteFn: (client, draft) => draft.Active(false)
        });

    loader({ Id: S.sample(domain.Id) }, 30);

    return {
        Model: domain,
        PortLookups: portLookups,
        CapabilityLookups: capabilityLookups
    };
}
export type BerthLookups = ReturnType<typeof BerthLookups>;


// WEBPACK FOOTER //
// ./apps/portcall/berthlookups/model.ts